import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export function ChartIcon({ size = '1.5rem', ...props }: IconRootProps) {
  return (
    <IconRoot xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" size={size} {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z"
      />
    </IconRoot>
  )
}
